import { ReviewLinesLimiter, addToGlobalThisRet } from "@plugins";

window.addEventListener("load", () => initLinesLimiter());

function initLinesLimiter() {
    if (!window.mobileMedia) return;

    const reviews = document.querySelectorAll("body .js-reviews-line-limiter-init");

    reviews.forEach((review) => new ReviewLinesLimiter(review));
}

addToGlobalThisRet(initLinesLimiter, "initReviewsLineLimiter");
